<div
    class="agpr-socialPostSaveTool"
    (clickOutside)="closeSaveMenu($event)"
    exclude=".agpr-clickOutsideExcluded"
    [excludeBeforeClick]="true"
>
    <div
        class="agpr-socialPostSaveTool-splitButton"
    >
        <span
            *ngIf="selectedFolder || selectedTags.length > 0"
            class="fa-solid fa-circle"
        ></span>
        <div>
            <button
                pButton
                class="agpr-socialPostSaveTool-splitButton-saveButton"
                [ngClass]="{'agpr-socialPostSaveTool-splitButton-saveButton--disabled': selectedMentions.length <= 0 || disabled}"
                [id]="id + '.socialPostSaveTool.splitButtonSave'"
                icon="fa-regular fa-duotone fa-floppy-disk"
                (click)="savePost()"
                [agprTooltip]="disabled ? 'Social.postFeed.bulkSave.unavailable' : saveButtonTooltip"
                [escape]="false"
                tooltipPosition="left"
            ></button>
        </div>
        <button
            pButton
            class="agpr-socialPostSaveTool-splitButton-dropdown"
            [id]="id + '.socialPostSaveTool.splitButtonDropdown'"
            icon="fa-solid fa-angle-down"
            [agprTooltip]="showSaveMenu ? 'Social.saveTool.closeSaveTool' : 'Social.saveTool.openSaveTool'"
            tooltipPosition="top"
            (click)="openSaveMenu()"
        ></button>
    </div>
    <div
        *ngIf="showSaveMenu"
        class="agpr-socialPostSaveTool-saveMenu"
    >
        <div class="agpr-socialPostSaveTool-folderSelector">
            <agpr-autocomplete
                [id]="id + '.folderDropdown'"
                labelField="name"
                placeholder="Monitoring.folderPicker.placeholder"
                [dropdown]="true"
                [(ngModel)]="selectedFolder"
                (clear)="clearFolder()"
                [customOptions]="folderAutocompleteOptions"
                [suggestions]="folderService.all$"
                [clearOnBlur]="false"
                (itemSelected)="selectFolder()"
                [style]="agprComponentStyleEnum.socialPlus"
                ariaLabel="Monitoring.folderPicker.tooltip"
            ></agpr-autocomplete>
            <agpr-button
                class="agpr-socialPostSaveTool-toolbarIcon"
                [ngClass]="{
                    'agpr-socialPostSaveTool-toolbarIcon--lock': folderSettingsLocked,
                    'agpr-socialPostSaveTool-toolbarIcon--unlock': !folderSettingsLocked
                }"
                [style]="buttonTypes.link"
                [id]="id + '.folderSettings.lock'"
                (click)="toggleFolderLock()"
                [icon]="folderSettingsLocked ? 'fa-regular fa-duotone fa-lock fa-duotone' : 'fa-regular fa-duotone fa-unlock'"
                [tooltip]="folderSettingsLocked ? 'Monitoring.result.saveSettings.unlock' : 'Monitoring.result.saveSettings.lock'"
                tooltipPosition="top"
            ></agpr-button>
        </div>
        <div class="agpr-socialPostSaveTool-tagSelector">
            <div class="agpr-socialPostSaveTool-tagSelector-autocomplete">
                <agpr-autocomplete
                    [id]="id + '.tagDropdown'"
                    labelField="name"
                    placeholder="Monitoring.result.saveWithTags"
                    [dropdown]="true"
                    [(ngModel)]="selectedTags"
                    (itemSelected)="selectTag()"
                    [customOptions]="tagsAutocompleteOptions"
                    [suggestions]="tagsService.all$"
                    [multiSelection]="true"
                    [style]="agprComponentStyleEnum.socialPlus"
                    ariaLabel="Monitoring.result.selectTags"
                ></agpr-autocomplete>
                <agpr-button
                    class="agpr-socialPostSaveTool-toolbarIcon"
                    [ngClass]="{
                        'agpr-socialPostSaveTool-toolbarIcon--lock': tagSettingsLocked,
                        'agpr-socialPostSaveTool-toolbarIcon--unlock': !tagSettingsLocked
                    }"
                    [style]="buttonTypes.link"
                    [id]="id + '.tagSettings.lock'"
                    (click)="toggleTagLock()"
                    [icon]="tagSettingsLocked ? 'fa-regular fa-lock fa-duotone' : 'fa-regular fa-duotone fa-unlock'"
                    [tooltip]="tagSettingsLocked ? 'Monitoring.result.saveSettings.unlock' : 'Monitoring.result.saveSettings.lock'"
                    tooltipPosition="top"
                ></agpr-button>
            </div>
            <agpr-chip-container
                #tagChipsComponent
                [id]="id + '.tagChipsContainer'"
                class="agpr-socialPostSaveTool-tagSelector-chipContainer agpr-clickOutsideExcluded"
                [chips]="tagChips"
                overflowMessage="Monitoring.result.saveSettings.tags.overflow"
                (removeChip)="unselectTagChip($event)"
                [style]="agprComponentStyleEnum.social"
            ></agpr-chip-container>
        </div>
        <div class="agpr-socialPostSaveTool-actionContainer">
            <agpr-button
                class="agpr-socialPostSaveTool-actionContainer-clearButton"
                [ngClass]="{'agpr-socialPostSaveTool-actionContainer-clearButton--visible': selectedFolder || selectedTags.length > 0 }"
                label="Core.button.clear"
                (click)="clearSettings()"
                tooltip="Monitoring.result.saveSettings.clear"
                [style]="buttonTypes.secondary"
            ></agpr-button>
            <agpr-button
                label="save"
                [disabled]="selectedMentions.length <= 0 || disabled"
                (click)="savePost()"
                [style]="buttonTypes.primaryB"
                [agprTooltip]="disabled ? 'Social.postFeed.bulkSave.unavailable' : null"
                tooltipPosition="left"
            ></agpr-button>
        </div>
    </div>
</div>
